<template>
  <li class="list-item">
    <div class="single-item p-0">
      <div class="d-flex">
        <!-- image -->
        <div class="product-image rounded">
          <img :src="baseImage(product)" :class="{ 'image-placeholder': !hasBaseImage(product) }" alt="product image" />
        </div>
        <!-- details -->
        <div class="d-flex w-100">
          <div class="d-flex flex-column justify-content-around w-100">
            <h6>{{ product.name }}</h6>
            <div>
              <span class="text-primary" v-show="qty">
                Qty: <span>{{ qty }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </li>
</template>

<script>
export default {
  name: 'ProductsListItem',
  props: { product: { type: Object, required: true }, qty: { type: String | Number, required: false, default: null } },
  methods: {
    hasBaseImage(product) {
      return product.base_image !== null && product.base_image !== ''
    },
    baseImage(product) {
      if (this.hasBaseImage(product)) return product.base_image

      return `${window.Trillion.baseUrl}/themes/storefront/public/images/image-placeholder.png`
    }
  }
}
</script>

<style lang="scss">
.list-item {
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.single-item {
  position: relative;
  display: flex;
  padding: 6px 20px;
  flex-direction: column !important;
}

.product-image {
  margin-right: 0.4rem;
  overflow: hidden;

  img {
    height: 80px;
    width: 75px;
    object-fit: contain;
  }

  .image-placeholder {
    height: 80px;
    width: 75px;
  }
}

.product-name {
  font-size: 14px;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 3px;
  color: var(--color-black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  vertical-align: top;
  cursor: default;
}
</style>
